import { IProps } from "../RightMenuContainer";
import { Container } from "./styled";

const RightMenu = (props: IProps) => {
  return <Container {...props}>{props.children}</Container>;
};

export default RightMenu;
